import * as d3 from 'd3';
import React, { useEffect } from 'react';
import havana from '../../../../data/havana.js';

function Genes (props) {

    const slot = props.slot,
        size = props.size,
        interval = [props.locus.low, props.locus.high],
        settings = props.settings,
        scalePosition = props.scalePosition;

    const data = havana.filter(el => el.chromosome === slot.chr && el.stop > slot.low && el.start < slot.high)
    
    useEffect(()=>{

        function colorGene (d) {
            if (interval[0] === undefined) return settings.blue2
            else if (interval[1] < d.start || interval[0] > d.stop) return settings.blue2
            else return settings.white
        }

        function distributeGene (gene) {
            if (data.length < 5) return (gene%2+1)*size.genes/2.5 + size.margin.top
            else if (data.length > 10) return (gene%4+1)*size.genes/5 + size.margin.top
            else return (gene%3+1)*size.genes/3.75 + size.margin.top
        }

        function drawArrow (d,i) {
            var point, dir;
            if (d.direction === '+') {point = d.stop; dir = -3}
            else {point = d.start; dir = 3};

            if (point > slot.high || point < slot.low) return undefined
            else {
                var x = scalePosition(point),
                    y = distributeGene(i)
                var corner1 = x + ',' + y,
                    corner2 = (x+dir) + ',' + (y-dir),
                    corner3 = (x+dir) + ',' + (y+dir);
            return corner1 + ' ' + corner2 + ' ' + corner3;
            }
        }

        d3.select('#genes_arrows')
            .selectAll('g')
            .data(data, d => d.gene_name)
            .join(
                function(enter){
                    var geneList = enter.append('g');
                    geneList.append('line')
                        .attr('x1', d => scalePosition(d.start))
                        .attr('x2', d => scalePosition(d.stop))
                        .attr('y1', (d,i) => distributeGene(i))
                        .attr('y2', (d,i) => distributeGene(i))
                        .style('stroke', d => colorGene(d))
                        .style('stroke-width', '1px')
                        .transition().style('opacity', 1);
                    geneList.append('polygon')
                        .attr('points', (d,i) => drawArrow(d,i))
                        .attr('fill', d => colorGene(d))
                        .transition().style('opacity', 1);
                    geneList.append('text')
                        .html(d => d.gene_name)
                        .attr('x', d => (scalePosition(d.start)+scalePosition(d.stop))/2)
                        .attr('y', (d,i) => distributeGene(i) -4)
                        .attr('class', 'smallText')
                        .style('text-anchor', 'middle')
                        .transition().style('opacity', 1);
                    return geneList
                },
                function(update){
                    update.select('line').transition().duration(500)
                        .attr('x1', d => scalePosition(d.start))
                        .attr('x2', d => scalePosition(d.stop))
                        .attr('y1', (d,i) => distributeGene(i))
                        .attr('y2', (d,i) => distributeGene(i))
                        .style('stroke', d => colorGene(d));
                    update.select('polygon').transition().duration(500)
                        .attr('points', (d,i) => drawArrow(d,i))
                        .attr('fill', d => colorGene(d))
                    update.select('text')
                        .html(d => d.gene_name)
                        .transition().duration(500)
                        .attr('x', d => (scalePosition(d.start)+scalePosition(d.stop))/2)
                        .attr('y', (d,i) => distributeGene(i) -4)
                        .style('fill', d => colorGene(d));
                },
                function(exit){
                    exit.transition().style('opacity', 0).remove()   
                })

    })

    return (
        <g id='genes02'>
            <rect id='genes_background'
                x={size.margin.left}
                y={size.margin.top}
                width={size.width-size.margin.left}
                height={size.genes}
                fill = {settings.blue1}
                style ={{opacity: 0.1}}
                />
            <g id='genes_arrows'></g>
        </g>
    )
    
}
export default Genes;